import React from 'react';
import './InstagramSection.css';

const InstagramSection = () => {
  return (
    <section className="insta-section" id="instagram">
      <div className="insta-bg-glow glow-left"></div>
      <div className="insta-bg-glow glow-right"></div>

      <div className="container">

        <div className="insta-head reveal">
          <span className="insta-mini">
            Social-First Storytelling
          </span>

          <h2>
            Reels That Stop The <span>Scroll</span>
          </h2>

          <p>
            Crafted for weddings, celebrations & unforgettable emotions —
            delivered with cinematic edits and viral-ready storytelling.
          </p>
        </div>

        <div className="insta-layout">

          <div className="insta-card reveal rd1">
            <div className="insta-topbar">
              <div className="insta-profile">
                <div className="insta-avatar">
                  G
                </div>

                <div>
                  <h4>@go._snap</h4>
                  <span>Birthday Reel</span>
                </div>
              </div>

              <div className="insta-badge">
                Viral Edit
              </div>
            </div>

            <div className="reel-frame">
    <iframe
      src="https://www.instagram.com/reel/DaXGbiOT_Db/embed"
      title="Instagram Reel 1"
      frameBorder="0"
      scrolling="no"
      allowTransparency="true"
      allowFullScreen={true}
    ></iframe>
  </div>

          </div>

          <div className="insta-card featured reveal rd2">

            <div className="floating-tag">
              Most Loved Reel
            </div>

            <div className="insta-topbar">
              <div className="insta-profile">
                <div className="insta-avatar orange">
                  G
                </div>

                <div>
                  <h4>@go._snap</h4>
                  <span>Luxury Wedding Reel</span>
                </div>
              </div>

              {/* <div className="insta-badge orange">
                Trending
              </div> */}
            </div>

            <div className="reel-frame featured-frame">
              <iframe
                src="https://www.instagram.com/reel/DXzgyQBTOEy/embed"
                allowTransparency="true"
                allowFullScreen={true}
                frameBorder="0"
                scrolling="no"
                title="Instagram Reel 2"
              ></iframe>
            </div>
          </div>

        </div>

        <div className="insta-cta reveal rd3">
          <div>
            <span>Want your event to look this cinematic?</span>
            <h3>Book Your Reel Experience With GoSnap</h3>
          </div>

          <a
            href="https://instagram.com/go._snap"
            target="_blank"
            rel="noopener noreferrer"
            className="insta-btn"
          >
            View Instagram
          </a>
        </div>

      </div>
    </section>
  );
};

export default InstagramSection;